import React from 'react';
import { Card, Grid, Link, Typography } from '@mui/material';
import FieldText from '../../../../components/general/fields/fieldText';
import { usePqrFilters } from './hook';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { PqrFiltersProps } from './props';
import { LayoutPqrWeb } from '../../../../layout/pqr_web';
import { formatParams } from '../../../../../shared/utils/params';
import AutocompleteField from '../../../../components/general/fields/autocompleteField';
import { PQRWEB_SURVEY_RESPONSE } from '../../../../../routes/paths';
import Divider from '@mui/material/Divider';
import { ISelect } from '../../../../../shared/types/shared';
import { useLocation } from 'react-router-dom';

export const PqrFiltersWeb = ({ survey }: PqrFiltersProps) => {
    const location = useLocation();
    const surveyAlreadyAnswered = location.state?.surveyAlreadyAnswered;
    const surveySuccess = location?.state?.surveySuccess;

    const {
        formik,
        types,
        handleFormSubmit,
        results,
        hasSearched,
        handleFormClear,
        getSearchStatusMessage,
        getSurveyStatusMessage,
        isLoading,
        isCloseStatus,
        isResponseSurvey,
        isMessageInfo,
        isSolvedStatus,
    } = usePqrFilters(survey);

    return (
        <>
            <LayoutPqrWeb
                title={
                    survey ? 'Encuesta de casos PQR' : 'Búsqueda de casos PQR'
                }
            />
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6} md={4} mt={10}>
                    <FieldText
                        label="PQR ID"
                        name="consecutiveFormat"
                        size="small"
                        touched={formik.touched.consecutiveFormat}
                        errors={formik.errors.consecutiveFormat}
                        value={formik.values.consecutiveFormat}
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4} mt={10}>
                    <FieldText
                        label="Identificación"
                        name="document"
                        size="small"
                        touched={formik.touched.document}
                        errors={formik.errors.document}
                        value={formik.values.document}
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4} mt={10}>
                    <AutocompleteField
                        data={formatParams(types)}
                        label="Tipo de documento"
                        name="typeDocument"
                        size="small"
                        touched={formik.touched.typeDocument}
                        errors={formik.errors.typeDocument}
                        value={formik.values.typeDocument as string}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('typeDocument', value)
                        }
                    />
                </Grid>
                <Grid item xs={12}>
                    <LoadingButtonGeneral
                        disabled={isLoading}
                        title="Buscar"
                        sx={{ mr: 1 }}
                        onClick={handleFormSubmit}
                    />
                    <LoadingButtonGeneral
                        title="Limpiar"
                        variant="outlined"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
                            handleFormClear(e)
                        }
                    />
                </Grid>
                {hasSearched && (
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        style={{ minHeight: '60vh' }}
                    >
                        <Card
                            sx={{
                                maxWidth: '650px',
                                padding: '50px',
                                textAlign: 'center',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                            }}
                        >
                            {results ? (
                                <>
                                    <Typography
                                        variant="h6"
                                        color="primary.main"
                                        paragraph
                                    >
                                        {survey
                                            ? getSurveyStatusMessage(
                                                results.info?.status?.code ||
                                                      ''
                                            )
                                            : getSearchStatusMessage(
                                                results.info?.status?.code ||
                                                      '',
                                                results?.statusManagement ||
                                                      {},
                                                (
                                                      results?.redirect
                                                          ?.area1 as ISelect
                                                )?.name || '',
                                                (
                                                      results?.responseMedium
                                                          ?.responseMedium as ISelect
                                                )?.name || ''
                                            )}
                                    </Typography>
                                    {isMessageInfo && (
                                        <Typography
                                            variant="h6"
                                            style={{ marginTop: '16px' }}
                                            color="primary.main"
                                        >
                                            Cualquier información adicional no
                                            olvide que puede contactarse con
                                            nosotros a través del #345 opción 3,
                                            línea nacional 018000 910 554, en
                                            Bogotá (+57) 601 348 7555 o
                                            escribirnos a nuestro correo
                                            electrónico y con gusto será
                                            atendida.
                                        </Typography>
                                    )}
                                    {isCloseStatus && !isResponseSurvey && (
                                        <Typography
                                            variant="h6"
                                            style={{ marginTop: '16px' }}
                                            color="primary.main"
                                        >
                                            Agradecemos su retroalimentación
                                            frente al proceso de atención
                                            recibido en este caso, respondiendo
                                            una breve encuesta disponible en el
                                            siguiente enlace.
                                            <br />
                                            <br />
                                            <Link
                                                href={`${PQRWEB_SURVEY_RESPONSE}/${results?.id}`}
                                                mt={2}
                                            >
                                                Diligenciar Encuesta
                                            </Link>
                                        </Typography>
                                    )}
                                    {isSolvedStatus && (
                                        <Typography
                                            variant="h6"
                                            style={{ marginTop: '16px' }}
                                            color="primary.main"
                                        >
                                            Para información adicional no olvide
                                            que puede contactarse con nosotros a
                                            través del #345 opción 3, línea
                                            nacional 018000 910 554, en Bogotá
                                            (601) 3487555 o escribirnos en
                                            nuestro correo electrónico y con
                                            gusto será atendida.
                                        </Typography>
                                    )}
                                    <Divider style={{ margin: '16px 0' }} />
                                    <Typography
                                        variant="h6"
                                        color="primary.main"
                                    >
                                        Cordial saludo,
                                    </Typography>
                                    <Typography
                                        variant="h6"
                                        color="primary.main"
                                    >
                                        Gerencia de Servicio
                                        <br />
                                        contactenos@previsora.gov.co
                                    </Typography>
                                </>
                            ) : (
                                <Typography variant="h6" color="primary.main">
                                    No se encontraron resultados.
                                </Typography>
                            )}
                        </Card>
                    </Grid>
                )}
                {surveyAlreadyAnswered && (
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        style={{ minHeight: '60vh' }}
                    >
                        <Card
                            sx={{
                                maxWidth: '650px',
                                padding: '50px',
                                textAlign: 'center',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                            }}
                        >
                            {' '}
                            <Typography variant="h6" color="primary.main">
                                La PQR consultada ya tiene encuesta realizada.
                            </Typography>
                        </Card>
                    </Grid>
                )}
                {surveySuccess && (
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        style={{ minHeight: '60vh' }}
                    >
                        <Card
                            sx={{
                                maxWidth: '650px',
                                padding: '50px',
                                textAlign: 'center',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                            }}
                        >
                            {' '}
                            <Typography variant="h6" color="primary.main">
                                ¡Felicidades! La encuesta se creó
                                satisfactoriamente.
                            </Typography>
                        </Card>
                    </Grid>
                )}
            </Grid>
        </>
    );
};
